export default __webpack_public_path__ + "static/1bcd21c442d843e6ac42793479492d30.ttf";